import { registerCommasFilter, registerCreditsFilter } from '@/vue-shared/utils/common-filters';

export function registerFilters (): void {
	registerCommasFilter();
	registerCreditsFilter();
}
